import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './attachments.component.scss';
var Attachments = /** @class */ (function (_super) {
    tslib_1.__extends(Attachments, _super);
    function Attachments(element) {
        return _super.call(this, element) || this;
    }
    Attachments.prototype.init = function () {
        // Check for browsers that do not support "stroke-dasharray"
        var isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g) || !!navigator.userAgent.match(/Edge/g);
        var svgDashArray = '';
        if (!isIE) {
            svgDashArray = 'stroke-dasharray="48"';
        }
        this.svg = "<svg class=\"attachments__checkmark\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\"><circle class=\"attachments__checkmark-circle\" cx=\"48\" cy=\"48\" r=\"48\" fill=\"none\" /><path class=\"attachments__checkmark-check\" fill=\"none\" d=\"M14.1 27.2l7.1 7.2 16.7-16.8\" " + svgDashArray + " /></svg>";
        this.downloadItems = Array.from(this.element.querySelectorAll('.js-download-items'));
    };
    Attachments.prototype.bindEvents = function () {
        var _this = this;
        this.downloadItems.map(function (item) { return item.addEventListener('click', function (event) {
            _this.markAsDownloaded(event);
        }); });
    };
    Attachments.prototype.markAsDownloaded = function (event) {
        if (!event.currentTarget.classList.contains('js-downloaded-item')) {
            event.currentTarget.classList.add('js-download-item');
            this.showDownloadedIndicator();
        }
    };
    Attachments.prototype.showDownloadedIndicator = function () {
        var _this = this;
        var downloadedItem = this.element.querySelector('.js-download-item');
        var downloadedIndicator = downloadedItem.querySelector('.attachments__indicator');
        var downloadedItemIcon = downloadedItem.querySelector('.attachments__icon-container');
        downloadedIndicator.classList.add('attachments__indicator--complete');
        downloadedItemIcon.classList.add('attachments__icon-container--hidden');
        setTimeout(function () {
            downloadedItem.querySelector('.attachments__indicator').innerHTML = _this.svg;
            downloadedItem.classList.add('js-downloaded-item');
            downloadedItem.classList.remove('js-download-item');
        }, 250);
    };
    return Attachments;
}(Base));
export { Attachments };



//////////////////
// WEBPACK FOOTER
// ./components/attachments/attachments.component.ts
// module id = 118
// module chunks = 0